import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { getFlightStatusLabel } from 'constants/flightBooking';
import cn from 'utils/classnames';

import styles from './FlightStatusBadge.module.scss';

// Statuses not listed here (waiting, issuing, unknown) use the Warning tone.
const TONE = {
  ISSUED: 'Success',
  COMPLETED: 'Success',
  REFUNDED: 'Success',
  ISSUE_FAILED: 'Danger',
  CANCELLED: 'Muted',
  EXPIRED: 'Muted',
};

function FlightStatusBadge({ status }) {
  return (
    <span className={cn(styles.Badge, styles[TONE[status] || 'Warning'])}>
      {getFlightStatusLabel(status)}
    </span>
  );
}

FlightStatusBadge.propTypes = {
  status: PropTypes.string,
};

FlightStatusBadge.defaultProps = {
  status: '',
};

export default memo(FlightStatusBadge);
